import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      // name用于定位异页面，跳转自动定位指定锚点
      name: 'homePage',
      component: () => import('@/views/logic/homePage/index')
    },
    {
      path: '/logic/homePage',
      // name用于定位异页面，跳转自动定位指定锚点
      name: 'homePage',
      component: () => import('@/views/logic/homePage/index')
    },
    {
      path: '/logic/contactUs',
      name: 'contactUs',
      component: () => import('@/views/logic/contactUs/index')
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js